import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useRegionalLink } from 'hooks/useRegionalLink';

import { useAuthState } from '../../../../contexts/auth-context';
import { links } from 'data/constants';

import classes from './PageStatusCode.module.scss';

const pageCodes = {
  403: {
    img: '403.png',
    title: 'activity:pageForbidden.TITLE',
    text: 'activity:pageForbidden.TEXT',
    button: 'activity:pageForbidden.BUTTON'
  },
  404: {
    img: '404.png',
    title: 'activity:pageNotFound.TITLE',
    text: 'activity:pageNotFound.TEXT',
    button: 'activity:pageNotFound.BUTTON'
  }
};

const PageStatusCode = ({ statusCode }) => {
  const { t } = useTranslation(['activity']);
  const { auth } = useAuthState();
  const pageCode = statusCode in pageCodes ? statusCode : 404;
  const generateRegionalPath = useRegionalLink();

  useEffect(() => {
    const backgroundContainer = document.getElementById('layoutContainer');
    backgroundContainer.style.backgroundImage = `url(${links.imagesBaseUrl}/images/cubes.png)`;
    backgroundContainer.style.backgroundRepeat = 'no-repeat';
    return () => {
      backgroundContainer.style.backgroundImage = null;
    };
  }, []);

  return auth.isAuthenticated ? (
    <Grid container flexDirection="column" className={cn(classes.main)}>
      <img
        className={classes.image}
        src={`${links.imagesBaseUrl}/images/${pageCodes[pageCode].img}`}
      />
      <Typography variant="h2" className={classes.title}>
        {t(`${pageCodes[pageCode].title}`)}
      </Typography>
      <Typography variant="body2" className={classes.text}>
        {t(`${pageCodes[pageCode].text}`)}
      </Typography>
      <Link
        className={classes.button}
        to={generateRegionalPath('/customers/all-tenants')}
      >
        {t(`${pageCodes[pageCode].button}`)}
      </Link>
    </Grid>
  ) : (
    <Redirect to="/login" />
  );
};

PageStatusCode.propTypes = {
  statusCode: PropTypes.string.isRequired
};

export default PageStatusCode;
